import { gettext } from '@eventbrite/i18n';

export const CATEGORY_TAG_TYPE = 'Category';

//Eventbrite Category ID Mapping
export const BUSINESS = 101;
export const SCIENCE = 102;
export const MUSIC = 103;
export const FILM = 104;
export const PERFORMING = 105;
export const FASHION = 106;
export const HEALTH = 107;
export const SPORTS = 108;
export const TRAVEL = 109;
export const FOOD = 110;
export const CHARITY = 111;
export const POLITICS = 112;
export const COMMUNITY = 113;
export const RELIGION = 114;
export const FAMILY_EDUCATION = 115;
export const SEASONAL = 116;
export const HOME_LIFESTYLE = 117;
export const AUTO_BOAT_AIR = 118;
export const HOBBIES = 119;
export const SCHOOL = 120;
export const OTHER = 199;

export const EVENTBRITE_CATEGORY = 'EventbriteCategory';
export const BUSINESS_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${BUSINESS}`;
export const SCIENCE_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${SCIENCE}`;
export const MUSIC_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${MUSIC}`;
export const FILM_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${FILM}`;
export const PERFORMING_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${PERFORMING}`;
export const FASHION_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${FASHION}`;
export const HEALTH_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${HEALTH}`;
export const SPORTS_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${SPORTS}`;
export const TRAVEL_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${TRAVEL}`;
export const FOOD_AND_DRINK_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${FOOD}`;
export const CHARITY_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${CHARITY}`;
export const POLITICS_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${POLITICS}`;
export const COMMUNITY_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${COMMUNITY}`;
export const RELIGION_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${RELIGION}`;
export const FAMILY_EDUCATION_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${FAMILY_EDUCATION}`;
export const SEASONAL_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${SEASONAL}`;
export const HOME_LIFESTYLE_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${HOME_LIFESTYLE}`;
export const AUTO_BOAT_AIR_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${AUTO_BOAT_AIR}`;
export const HOBBIES_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${HOBBIES}`;
export const SCHOOL_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${SCHOOL}`;
export const OTHER_EVENTBRITE_CATEGORY = `${EVENTBRITE_CATEGORY}/${OTHER}`;

export const EVENTBRITE_CATEGORY_ID_STRINGS = [
    BUSINESS_EVENTBRITE_CATEGORY,
    SCIENCE_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    FILM_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    FASHION_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
    TRAVEL_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    CHARITY_EVENTBRITE_CATEGORY,
    POLITICS_EVENTBRITE_CATEGORY,
    COMMUNITY_EVENTBRITE_CATEGORY,
    RELIGION_EVENTBRITE_CATEGORY,
    FAMILY_EDUCATION_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    HOME_LIFESTYLE_EVENTBRITE_CATEGORY,
    AUTO_BOAT_AIR_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    SCHOOL_EVENTBRITE_CATEGORY,
    OTHER_EVENTBRITE_CATEGORY,
];

export const EVENTBRITE_CATEGORY_TO_REFINEMENT = {
    [BUSINESS_EVENTBRITE_CATEGORY]: 'business',
    [SCIENCE_EVENTBRITE_CATEGORY]: 'science-and-tech',
    [MUSIC_EVENTBRITE_CATEGORY]: 'music',
    [FILM_EVENTBRITE_CATEGORY]: 'film-and-media',
    [PERFORMING_EVENTBRITE_CATEGORY]: 'arts',
    [FASHION_EVENTBRITE_CATEGORY]: 'fashion',
    [HEALTH_EVENTBRITE_CATEGORY]: 'health',
    [SPORTS_EVENTBRITE_CATEGORY]: 'sports-and-fitness',
    [TRAVEL_EVENTBRITE_CATEGORY]: 'travel-and-outdoor',
    [FOOD_AND_DRINK_EVENTBRITE_CATEGORY]: 'food-and-drink',
    [CHARITY_EVENTBRITE_CATEGORY]: 'charity-and-causes',
    [POLITICS_EVENTBRITE_CATEGORY]: 'government',
    [COMMUNITY_EVENTBRITE_CATEGORY]: 'community',
    [RELIGION_EVENTBRITE_CATEGORY]: 'spirituality',
    [FAMILY_EDUCATION_EVENTBRITE_CATEGORY]: 'family-and-education',
    [SEASONAL_EVENTBRITE_CATEGORY]: 'holiday',
    [HOME_LIFESTYLE_EVENTBRITE_CATEGORY]: 'home-and-lifestyle',
    [AUTO_BOAT_AIR_EVENTBRITE_CATEGORY]: 'auto-boat-and-air',
    [HOBBIES_EVENTBRITE_CATEGORY]: 'hobbies',
    [SCHOOL_EVENTBRITE_CATEGORY]: 'school-activities',
    [OTHER_EVENTBRITE_CATEGORY]: 'other',
};

export const EVENTBRITE_CATEGORY_MAPPING = {
    [BUSINESS_EVENTBRITE_CATEGORY]: gettext('Business'),
    [SCIENCE_EVENTBRITE_CATEGORY]: gettext('Science & Tech'),
    [MUSIC_EVENTBRITE_CATEGORY]: gettext('Music'),
    [FILM_EVENTBRITE_CATEGORY]: gettext('Film & Media'),
    [PERFORMING_EVENTBRITE_CATEGORY]: gettext('Performing & Visual Arts'),
    [FASHION_EVENTBRITE_CATEGORY]: gettext('Fashion'),
    [HEALTH_EVENTBRITE_CATEGORY]: gettext('Health'),
    [SPORTS_EVENTBRITE_CATEGORY]: gettext('Sports & Fitness'),
    [TRAVEL_EVENTBRITE_CATEGORY]: gettext('Travel & Outdoor'),
    [FOOD_AND_DRINK_EVENTBRITE_CATEGORY]: gettext('Food & Drink'),
    [CHARITY_EVENTBRITE_CATEGORY]: gettext('Charity & Causes'),
    [POLITICS_EVENTBRITE_CATEGORY]: gettext('Government'),
    [COMMUNITY_EVENTBRITE_CATEGORY]: gettext('Community'),
    [RELIGION_EVENTBRITE_CATEGORY]: gettext('Spirituality'),
    [FAMILY_EDUCATION_EVENTBRITE_CATEGORY]: gettext('Family & Education'),
    [SEASONAL_EVENTBRITE_CATEGORY]: gettext('Holiday'),
    [HOME_LIFESTYLE_EVENTBRITE_CATEGORY]: gettext('Home & Lifestyle'),
    [AUTO_BOAT_AIR_EVENTBRITE_CATEGORY]: gettext('Auto, Boat & Air'),
    [HOBBIES_EVENTBRITE_CATEGORY]: gettext('Hobbies'),
    [SCHOOL_EVENTBRITE_CATEGORY]: gettext('School Activities'),
    [OTHER_EVENTBRITE_CATEGORY]: gettext('Other'),
};
